// src/components/Menu/index.js
import React from 'react';

import styles from './Menu.module.css'; 
import Footer from '../Footer';

// Impor ikon-ikon untuk tombol
import iconTarikTambang from '../../assets/menu-icon-tarik-tambang.png';
import iconPanjatPinang from '../../assets/menu-icon-panjat-pinang.png';
import iconBalapKarung from '../../assets/menu-icon-balap-karung.png';
import iconFauna from '../../assets/fauna-race-icon.png';
import iconPinisi from '../../assets/pinisi-kata-icon.png';
import iconPilahSampah from '../../assets/pilah-sampah-icon.png';

const gameButtonsData = [
    { id: 'tarik-tambang', text: 'Tarik Tambang', icon: iconTarikTambang, style: styles.tarikTambang },
    { id: 'panjat-pinang', text: 'Panjat Pinang', icon: iconPanjatPinang, style: styles.panjatPinang },
    { id: 'balap-karung', text: 'Balap Karung', icon: iconBalapKarung, style: styles.balapKarung },
    { id: 'fauna-race', text: 'Fauna Race', icon: iconFauna, style: styles.faunaRace },
    { id: 'pinisi-kata', text: 'Asah Otak Asah Kata', icon: iconPinisi, style: styles.pinisiKata },
    { id: 'pilah-sampah', text: 'Pilah Sampah Race', icon: iconPilahSampah, style: styles.pilahSampah },
];

function Menu({ onSelectGame }) {
    return (
        <>
            {/* Komponen background sekarang akan berfungsi dengan benar */}
            {/* <AnimatedIconsBackground />*/}

            {/* .menuScreen sekarang menjadi flex container utama */}
            <div className={styles.menuScreen}>
                {/* 
                  Container ini hanya untuk kartu menu, 
                  bukan untuk seluruh layar
                */}
                <div className={styles.container}>
                    
                    <div className={styles.buttonsWrapper}>
                        {gameButtonsData.map((game) => (
                            <button 
                                key={game.id}
                                className={`${styles.gameButton} ${game.style}`} 
                                onClick={() => onSelectGame(game.id)}
                            >
                                <div className={styles.iconWrapper}>
                                    <img src={game.icon} alt={game.text} className={styles.icon} />
                                </div>
                                <div className={styles.textWrapper}>
                                    {game.text}
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                {/* 
                  PERBAIKAN: Footer sekarang menjadi item flex terpisah di dalam .menuScreen,
                  memastikannya tidak akan tumpang tindih.
                */}
                <Footer />
            </div>
        </>
    );
}

export default Menu;